import { useState } from "react";
import AppShell from "@/components/AppShell";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Users, FileText, Timer, BarChart3 } from "lucide-react";
import { OverviewTab } from "@/components/receivables/OverviewTab";
import { CustomersTab } from "@/components/receivables/CustomersTab";
import { InvoicesTab } from "@/components/receivables/InvoicesTab";
import { AgingTab } from "@/components/receivables/AgingTab";

export default function Receivables() {
  const [tab, setTab] = useState("overview");
  return (
    <AppShell>
      <div className="mb-8">
        <div className="text-xs tracking-[0.2em] uppercase text-[var(--muted-text)]">Money in</div>
        <h1 className="font-display text-4xl mt-2">Receivables</h1>
        <p className="text-sm text-[var(--muted-text)] mt-1 max-w-xl">
          Customers, invoices you've sent, and how long money has been outstanding.
        </p>
      </div>
      <Tabs value={tab} onValueChange={setTab} className="space-y-6">
        <TabsList className="bg-[var(--hover)]">
          <TabsTrigger value="overview" data-testid="tab-ar-overview"><BarChart3 className="w-4 h-4 mr-2" /> Overview</TabsTrigger>
          <TabsTrigger value="invoices" data-testid="tab-invoices"><FileText className="w-4 h-4 mr-2" /> Invoices</TabsTrigger>
          <TabsTrigger value="customers" data-testid="tab-customers"><Users className="w-4 h-4 mr-2" /> Customers</TabsTrigger>
          <TabsTrigger value="aging" data-testid="tab-aged-ar"><Timer className="w-4 h-4 mr-2" /> Aged AR</TabsTrigger>
        </TabsList>
        <TabsContent value="overview"><OverviewTab onOpen={setTab} /></TabsContent>
        <TabsContent value="invoices"><InvoicesTab /></TabsContent>
        <TabsContent value="customers"><CustomersTab /></TabsContent>
        <TabsContent value="aging"><AgingTab /></TabsContent>
      </Tabs>
    </AppShell>
  );
}

// ---------------- Overview ----------------
